<script setup lang="ts">
import { KeySellingPoint } from "../../utils/API/Cart/cartAPISchema";

defineProps<{
  keySellingPoints: KeySellingPoint[];
}>();
</script>

<template>
  <aside class="checkout-ksps layout-new-checkout__element">
    <div
      v-for="ksp in keySellingPoints"
      :key="ksp.heading"
      class="checkout-ksps__item"
    >
      <img :src="ksp.img" alt="" />
      <div class="checkout-ksps__content">
        <h3>{{ ksp.heading }}</h3>
        <div>
          {{ ksp.description }}
        </div>
      </div>
    </div>
  </aside>
</template>
